<template>
    <b-modal ref="notificationModal" id="notification-modal" class="notification__modal" title="Message center" no-close-on-backdrop hide-footer @hidden="hideModal">
        <div class="card">
            <p class="message_labels">
                <b-badge variant="info" v-if="currentMessage.user_id">User</b-badge>
                <b-badge variant="info" v-if="currentMessage.customer_id">Billing</b-badge>
                <b-badge variant="info" v-if="currentMessage.team_id">Team</b-badge>
            </p>
            <!-- <lottie-vue-player src="https://lottie.host/4a3e1122-a782-4153-8623-258b2e77cc20/u7zrHG9R1J.json" :player-controls="false" style="width: 200px; height:200px; margin: 0 auto;"></lottie-vue-player> -->
            <h3>{{ currentMessage.title }}</h3>
            <div v-if="currentMessage.text">
                <p v-for="(paragraph, key) in currentMessage.text">
                    {{ paragraph }}
                </p>
                <div class="mt-2" v-if="customerData && currentMessage.type === 'update_customer'">
                    <p><strong>Name:</strong><br> {{ customerData.name }}</p>
                    <p><strong>Billing communication email:</strong><br> {{ customerData.email_address }}</p>
                    <p><strong>Address:</strong><br> {{ customerData.address }} {{ customerData.postal_code }},<span v-if="customerData.area"> {{ customerData.area }},</span> {{ customerData.city }} {{ customerData.country }}</p>
                    <p><strong>Phone number (incase of emergency):</strong><br> <span v-if="customerData.phone">{{ customerData.phone }}</span><span v-else>-</span></p>
                    <p><strong>Vat number:</strong><br> <span v-if="customerData.phone">{{ customerData.vat_number }}</span><span v-else>-</span></p>
                    <p><strong>Connected teams:</strong></p>
                    <ul v-if="teams">
                        <li v-for="(team, index) in teams" :key="'team' + index" v-if="team.customer.id === customerData.id">{{ team.name }}</li>
                    </ul>

                    <div v-if="currentUser.id !== customerData.owner.id">
                        To make changes to the billing information, you must be the billing administrator. In this case that is <strong>{{ customerData.owner.first_name }} {{ customerData.owner.last_name }} {{ customerData.owner.email_address }}</strong>.
                    </div>
                </div>
            </div>
        </div>
        <div class="flex">
            <div>
                <img :src="'https://cdn.cyso.nl/fuga-assets/dist/images/avatars/' + currentMessage.sender.toLowerCase() + '.jpg'" class="message__sender" v-if="currentMessage.sender" />From {{ currentMessage.sender }}
            </div>
            <div class="ml-auto mt-2" v-if="currentMessage.onboarding">
                <a href="#"  @click.prevent="closeModalAndFindReg();">{{ currentMessage.linkText }}</a>
            </div>
            <div class="ml-auto mt-2" v-else>
                <a href="#"  @click.prevent="CloseModalAndGoTo();">{{ currentMessage.linkText }}</a>
            </div>
        </div>
        <hr>
        <p class="text-center"><small>If you need help, please contact us at support@fuga.cloud</small></p>
    </b-modal>
</template>

<script>
import { messageSeen } from '@/assets/js/api/message-center';

export default {
    data() {
        return {
            currentUser: this.$store.state.user.info,
            currentCustomer: this.$store.state.customer.info,
        };
    },

    computed: {
        currentMessage() {
            if (this.$store.state.notification.current) {
                return this.$store.state.notification.current;
            } else {
                return this.$store.state.notification.list;
            }
        },

        customerData() {
            if (this.currentMessage.customer_id) {
                let filteredData = this.$store.state.customer.list.find(item => item.id === this.currentMessage.customer_id)
                return filteredData;
            } else {
                return false;
            }
        },

        teams() {
            return this.$store.state.team.info;
        }
    },

    methods: {
        hideModal() {
            this.updateNotificationMessage(this.currentMessage)
        },

        updateNotificationMessage(item) {
            messageSeen(item)
            .then((response) => {
                this.fetchMessages();
            })
            .catch((error) => {
                this.showNotification('error', `Fetching your notifications has failed`);
                console.error(error);
                this.isLoading = false;
            });
        },

        CloseModalAndGoTo() {
            if (this.$router.currentRoute.name !== this.currentMessage.linkName) {
                this.$router.push({ name: this.currentMessage.linkName });
            }
            this.$root.$emit('bv::hide::modal','notification-modal');
        },

        closeModalAndFindReg() {
            this.$root.$emit('bv::hide::modal','notification-modal');
            this.findRegistrationStep();
        },
    },

    components: {
    },
}
</script>
<style scoped="scoped">
.message__sender {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-right: 20px;
}
.message_labels {
    position: absolute;
    top: -2px;
    right: 10px;
}
.message_labels .badge {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>
